import React, { useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { MergerDrawer } from "./mergerDrawer";


export const Summary = () => {
  

    return (
        <>
            <PageHeader />
            <DataBox />
            <MergerDrawer />
        </>
    )
}